export default __webpack_public_path__ + "static/media/nodata.0eca89df.svg";